export { default } from "./overview.web";
